<div
  class="scrollable-wrapper"
  [class.scrollable-wrapper--active]="enabled()"
  [class.scrollable-wrapper--horizontal]="enabled() && hasHorizontal">

  <div class="scrollable-content"
       [class.scrollable-content--active]="enabled()"
       [class.scrollable-content--x]="enabled() && hasHorizontal"
       [class.scrollable-content--y]="enabled() && hasVertical"
       #scrollContent (scroll)="onScroll()">
    <ng-content></ng-content>
  </div>

  @if (enabled() && showScrollbar) {
    <div class="scrollable-track" #scrollTrack (click)="onTrackClick($event)">
      <div
        class="scrollable-thumb"
        [style.height.px]="thumbHeight"
        [style.top.px]="thumbTop"
        (mousedown)="onThumbMouseDown($event)">
      </div>
    </div>
  }

  @if (enabled() && showScrollbarX) {
    <div class="scrollable-track scrollable-track--horizontal" #scrollTrackX (click)="onTrackClickX($event)">
      <div
        class="scrollable-thumb scrollable-thumb--horizontal"
        [style.width.px]="thumbWidth"
        [style.left.px]="thumbLeft"
        (mousedown)="onThumbMouseDownX($event)">
      </div>
    </div>
  }

</div>
